<template>
  <div class="homenav">
    <div class="device-tabs">
      <div class="list-wrap">
        <div class="list-wrap-hr"></div>
        <div class="device-btn-group" v-if="!$store.getters.isAppstoreMode">
          <div
            class="device-btn"
            @click="goServerPage"
            v-if="
              ($store.state.client == 'mac' ||
                $store.state.client == 'windows') &&
              $store.state.version > '2.3.2'
            "
          >
            <div class="left-top-icon">绑定码</div>
            <div class="go-server-icon"></div>
            <div class="device-btn-text">切换设备端</div>
          </div>
          <div class="device-btn" @click="onNavClick('/home/applications')">
            <div class="app-door-icon"></div>
            <div class="device-btn-text">工具箱</div>
          </div>
        </div>

        <div :class="{ list: true, nopadding: true }">
          <div
            @click="onNavClick(item.path)"
            v-for="(item, index) in list"
            v-bind:key="index"
            class="item"
            :class="{ activeWrap: currentTab == index }"
          >
            <div :class="activeClass(index)"></div>
            <div
              class="device-bind-wrap"
              :class="['device-bind-wrap-' + index]"
            >
              <div class="device-icon"></div>
              <div class="device-name">{{ item.name }}</div>
            </div>
          </div>
          <div
            class="item-add"
            @click="addDeviceClick"
            alt="添加设备"
            title="添加设备"
          >
            <div class="item-add-line"></div>
          </div>
        </div>
      </div>
    </div>
    <AddDevAlert
      v-if="isShowBindAlert"
      @showOrHideBindClick="showOrHideBindClick"
      @bindDeviceClick="bindDeviceClick"
    ></AddDevAlert>
    <BindLimitAlert
      @onCancelClick="hideBindLimitAlert"
      @onPayClick="onPayClick"
      v-if="isShowBindLimitAlert"
    ></BindLimitAlert>
    <div v-if="isBindSuccess == 1" class="bind-result-wrap">
      <div class="close_btn" @click="isBindSuccess = 0"></div>
      <div class="bind-result-text1">绑定成功</div>
      <div class="bind-result-text2">若未自动跳转请刷新页面</div>
      <div class="btns">
        <!-- <div class="cancel_btn" @click="isBindSuccess = 0">取消</div> -->
        <div class="qun_btn" @click="isBindSuccess = 0">确定</div>
      </div>
    </div>
    <div v-else-if="isBindSuccess == 2" class="bind-result-wrap">
      <div class="close_btn" @click="isBindSuccess = 0"></div>
      <div class="bind-result-text1">绑定失败</div>
      <div class="bind-result-text2">绑定码错误或失效</div>
      <div class="btns">
        <!-- <div class="cancel_btn" @click="isBindSuccess = 0">取消</div> -->
        <div class="qun_btn" @click="isBindSuccess = 0">确定</div>
      </div>
    </div>

    <AddDevice
      v-if="isAddDevice"
      @closeAddDeviceClick="closeAddDeviceClick"
      @getBindget="getBindget"
      :deviceLength="deviceLength"
    ></AddDevice>
  </div>
</template>

<script>
import AddDevAlert from "@/components/Node/AddDevAlert.vue";
import BindLimitAlert from "@/components/Node/BindLimitAlert.vue";
import AddDevice from "@/components/device/AddDevice.vue";
import { mapActions } from "vuex";
export default {
  components: {
    AddDevAlert,
    BindLimitAlert,
    AddDevice,
  },
  data: function () {
    return {
      isAddDevice: false,
      isBindSuccess: false,
      bindViewType: "",
      isShowBindLimitAlert: false,
      isShowBindAlert: false,
      list: [
        {
          name: "远程服务",
          path: "/home/node",
        },
        {
          name: "设备管理",
          path: "/home/devices",
        },
        // {
        // 	name: "工具箱",
        // 	path: "/home/tools",
        // },
        {
          name: "高级功能",
          path: "/home/viphome",
        },
      ],
    };
  },
  props: ["currentTab", "deviceLength"],
  methods: {
    ...mapActions([
      "bookRegister",
      "sendUserlog",
      "nodelist",
      "scanlist",
      "scan",
      "nodelistset",
      "bindget",
      "nodeDeviceInfo",
    ]),
    closeAddDeviceClick: function () {
      let _that = this;
      _that.isAddDevice = false;
    },
    addDeviceClick: function () {
      let _that = this;
      _that.isAddDevice = true;
    },

    goServerPage: function () {
      let _that = this;
      if (process.env.NODE_ENV !== "production") {
        window.location.href =
          "http://192.168.71.34:8081/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      } else {
        window.location.href =
          "http://yc.iepose.com/jdxb_server_pc_v4/?client=" +
          _that.$store.state.client +
          "&version=" +
          _that.$store.state.version;
      }
    },

    getBindget: function () {
      let _that = this;

      // _that.bindget([
      // 	function (err, data) {
      // 		if (data && data.terms && data.terms.length > 0) {
      // 			_that.list = data.terms;
      // 			console.log(_that.list);
      // 			_that.listOffline = [];
      // 			_that.listOnline = [];
      //
      // 			for (
      // 				let index = 0;
      // 				index < _that.list.length;
      // 				index++
      // 			) {
      // 				const element = _that.list[index];
      // 				let pidInfo = _that.$common.getInfoByPid(
      // 					element.peerid
      // 				);
      //
      // 				if (element.term && !element.term.name) {
      // 					element.term.name =
      // 						pidInfo.cname + pidInfo.dname;
      // 				}
      //
      // 				element.ip = "";
      // 				element.mac = "";
      // 				if (element.term && element.term.nic) {
      // 					for (
      // 						let j = 0;
      // 						j < element.term.nic.length;
      // 						j++
      // 					) {
      // 						const subItem = element.term.nic[j];
      // 						if (subItem.ipv4n && subItem.mac) {
      // 							element.ip = subItem.ipv4n;
      // 							element.mac = subItem.mac;
      // 						}
      // 					}
      // 				}
      // 				_that.getNodeDeviceInfo(element);
      // 			}
      // 		}
      // 	},
      // ]);
    },
    getNodeDeviceInfo: function (item) {
      let _that = this;
      _that.nodeDeviceInfo([
        item.peerid,
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.data.name && data.data.name != "0") {
              _that.$set(item, "comment", data.data.name);
            } else {
              _that.$set(item, "comment", "");
            }
          }
        },
      ]);
    },
    onPayClick: function () {
      let _that = this;
      _that.hideBindLimitAlert();
      _that.$router.push({ path: "/home/vip" });
    },
    bindDeviceClick: function (code) {
      let _that = this;

      _that.bookRegister([
        code,
        function (err, data) {
          // for test
          // data.rtn = 10216;
          // data.rtn = 0;
          // data.register = 1;
          if (data && !data.rtn && data.register) {
            _that.sendUserlog(["bindDevice_s", code]);

            let pid = data.pid;

            // _that.isBindSuccess = 1;
            // setTimeout(function () {
            // 	_that.isBindSuccess = 0;
            // 	window.location.reload();
            // }, 3000);
            _that.isShowBindCheck = true;
            _that.bindViewType = "success";

            _that.nodelist([
              pid,
              function (err, data) {
                if (!err) {
                  let hasServices = data.jd ? data.jd.length : 0;
                  _that.scan([
                    pid,
                    function (err, data) {
                      let ready = data.ready;
                      let timeoutSecond = ready ? 0 : 1000;
                      setTimeout(function () {
                        //扫描服务
                        _that.scanlist([
                          pid,
                          function (err, data) {
                            if (!err && data.jd && data.jd.length > 0) {
                              let searchServiceList =
                                _that.$common.buildSearchServiceList(
                                  "",
                                  "",
                                  [],
                                  data
                                );
                              let adds = [];
                              let maxService = 6 - hasServices;
                              for (
                                let i = 0;
                                i < searchServiceList.length;
                                i++
                              ) {
                                if (
                                  searchServiceList[i].dtype ||
                                  searchServiceList[i].status == 1
                                ) {
                                  //不添加没有类型或者离线设备
                                  if (adds.length >= maxService) {
                                    break;
                                  }
                                  adds.push(
                                    searchServiceList[i].mac +
                                      "|" +
                                      searchServiceList[i].port
                                  );
                                }
                              }
                              _that.nodelistset([
                                pid,
                                adds,
                                function (err, data) {},
                              ]);
                            }
                          },
                        ]);
                      }, timeoutSecond);
                    },
                  ]);
                }
              },
            ]);
            setTimeout(function () {
              window.location.reload();
            }, 3000);
          } else {
            // 绑定失败
            if (data && data.rtn == 10216) {
              // 数量限制
              // _that.messageFlag = true;
              // _that.messageType = "showBindLimit";
              _that.showBindLimitAlert();

              _that.sendUserlog(["bindDevice_f_limit", code + "|10216"]);
            } else {
              _that.sendUserlog(["bindDevice_f", code + "|" + data.rtn]);
              // _that.bindFailedTips = "错误码：" + data.rtn;
              // _that.bindViewType = "failed";
              // _that.isShowBindCheck = true;
              _that.isBindSuccess = 2;
              setTimeout(function () {
                _that.isBindSuccess = 0;
              }, 2000);
            }
          }
        },
      ]);
    },
    onNavClick: function (path) {
      let _that = this;
      if (path == "/home/viphome") {
        _that.$router.push("/home/viphome");
        // if (_that.$store.state.user.vip_left <= 0) {
        // 	_that.$router.push("/home/vipabout");
        // }else{
        // 	_that.$router.push(path);
        // }
      } else {
        _that.$router.push(path);
      }
    },
    currentClickClass: function (index) {
      let _that = this;
      return _that.currentTab == index ? "activeWrap" : "";
    },
    activeClass: function (index) {
      let _that = this;
      let bgClass = "";
      if (_that.currentTab == index) {
        if (_that.currentTab == 0) {
          bgClass = "activeLeftBg";
        } else if (_that.currentTab == 4 - 1) {
          bgClass = "activeRightBg";
        } else if (_that.currentTab > 0 && _that.currentTab < 4 - 1) {
          bgClass = "activeMiddleBg";
        }
      }
      return bgClass;
    },
    showBindLimitAlert: function () {
      this.isShowBindLimitAlert = true;
    },
    hideBindLimitAlert: function () {
      this.isShowBindLimitAlert = false;
    },
    showOrHideBindClick: function (data) {
      let _that = this;
      _that.isShowBindAlert = data;
    },
    onAddClick: function () {
      let _that = this;
      if (
        _that.$store.state.user.vip_left <= 0 &&
        _that.$store.state.bind_list.length >=
          _that.$store.state.limit.bind.normal
      ) {
        this.showBindLimitAlert();
      } else if (
        _that.$store.state.user.vip_left > 0 &&
        _that.$store.state.bind_list.length >= _that.$store.state.limit.bind.vip
      ) {
        this.showBindLimitAlert();
      } else {
        // alert("showOrHideBindClick");
        this.showOrHideBindClick(true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.homenav {
  .device-tabs {
    padding-right: 10px;
    padding-left: 10px;
    // background-image: url("../assets/home/node/tabs_shadow_bg.png");
    // background-repeat: no-repeat;
    // background-size: 100% 7px;
    // background-position: bottom;
    background-image: url("../../assets/home/node/tabs_shadow.png");
    background-repeat: no-repeat;
    background-size: 100% 7px;
    background-position: bottom;

    .list-wrap {
      position: relative;
      height: 84px;
      .list-wrap-hr {
        width: 100%;
        height: 1px;
        position: absolute;
        top: 5px;
        left: 0;
        background-color: #f5f5f5;
      }
      .arrow {
        display: inline-block;
        position: absolute;
        top: 6px;
        z-index: 3;
        width: 31px;
        height: 71px;
        background-color: rgba(251, 253, 255, 0.86);
        background-size: 10px 17px;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
      .arrow-left {
        background-image: url("../../assets/home/node/arrow_left.svg");
        left: 0;
      }
      .arrow-right {
        background-image: url("../../assets/home/node/arrow_right.svg");
        right: 94px;
        right: 185px;
      }
      .device-btn-group {
        position: absolute;
        right: 0;
        z-index: 3;
        top: 6px;

        .device-btn {
          height: 71px;
          width: 94px;
          background-color: #e8f5fe;
          box-sizing: border-box;
          text-align: center;
          display: inline-block;
          vertical-align: top;
          position: relative;

          .left-top-icon {
            padding: 2px 6px;
            font-size: 12px;
            line-height: 16px;
            color: #ffffff;
            background-color: #f55e55;
            border-radius: 0 8px;
            display: inline-block;
            position: absolute;
            left: -2px;
            top: -10px;
          }

          .device-btn-text {
            margin-top: 4px;
            color: #1f5de3;
            font-size: 12px;
          }
          .add-device-icon,
          .set-device-icon,
          .app-door-icon,
          .go-server-icon,
          .about-icon,
          .xbjf-icon {
            margin: 0 auto;
            margin-top: 18px;
            margin-bottom: 6px;
            width: 24px;
            height: 24px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
          .add-device-icon {
            background-image: url("../../assets/home/node/device_add.png");
          }
          .set-device-icon {
            background-image: url("../../assets/home/node/device_setting.png");
          }
          .about-icon {
            background-image: url("../../assets/home/node/about_icon.png");
          }
          .xbjf-icon {
            background-image: url("../../assets/home/node/xbjf_icon.svg");
          }
          .app-door-icon {
            background-image: url("../../assets/home/node/app_door_icon.svg");
          }
          .go-server-icon {
            width: 36px;
            height: 36px;
            margin-top: 8px;
            margin-bottom: 0;
            background-image: url("../../assets/home/node/go_server_icon_hover.svg");
          }
        }
        .device-btn:nth-child(2) {
          padding-left: 1px;
          background-image: url("../../assets/home/node/tab_line.png");
          background-size: 1px 41px;
          background-repeat: no-repeat;
          background-position: left center;
        }
        .device-btn:hover {
          cursor: pointer;
          opacity: 0.9;
        }
      }

      .list {
        padding-top: 6px;
        // padding-right: 125px;
        // padding-right: 220px;
        width: 675px;
        width: 846px;
        padding-left: 31px;
        white-space: nowrap;
        overflow-x: hidden;
        overflow-y: hidden;
        height: 78px;
        // background-image: url("../../assets/home/node/tabs_shadow.png");
        // background-repeat: no-repeat;
        // background-size: 100% 7px;
        // background-position: bottom;
        -ms-overflow-style: none;
        scrollbar-width: none;

        .item {
          position: relative;
          width: 189px;
          height: 71px;
          display: inline-block;
          background-color: #ebebeb;
          border-top-left-radius: 2px;
          box-sizing: border-box;
          cursor: pointer;

          .device-bind-wrap-0 {
            .device-icon {
              background-image: url(../../assets/homenav/item1.svg);
            }
          }
          .device-bind-wrap-1 {
            .device-icon {
              background-image: url(../../assets/homenav/item3.svg);
            }
          }
          .device-bind-wrap-2 {
            .device-icon {
              background-image: url(../../assets/homenav/item5.svg);
            }
          }
          .device-bind-wrap-3 {
            .device-icon {
              background-image: url(../../assets/homenav/itemVip.png);
            }
          }

          .device-bind-wrap {
            width: 100%;
            height: 100%;
            text-align: center;
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
            .device-icon {
              width: 28px;
              height: 28px;
              background-repeat: no-repeat;
              display: inline-block;
              vertical-align: top;
              margin-top: 21px;
              margin-right: 10px;
              background-size: 100% 100%;
            }
            .device-name {
              display: inline-block;
              vertical-align: top;
              height: 28px;
              line-height: 28px;
              margin-top: 22px;
              color: #666666;
              font-weight: bolder;
            }
          }
        }
        .item:nth-child(n + 2) {
          padding-left: 1px;
          background-image: url("../../assets/home/node/tab_line.png");
          background-size: 1px 52px;
          background-repeat: no-repeat;
          background-position: left center;
          // border-left: 1px solid #ffffff;
        }

        .item:hover,
        .activeWrap {
          background-color: #f0f3f8;
          .device-bind-wrap-0 {
            .device-icon {
              background-image: url(../../assets/homenav/item2.svg);
            }
          }
          .device-bind-wrap-1 {
            .device-icon {
              background-image: url(../../assets/homenav/item4.svg);
            }
          }
          .device-bind-wrap-2 {
            .device-icon {
              background-image: url(../../assets/homenav/item6.svg);
            }
          }
          .device-bind-wrap {
            .device-name {
              color: #444444;
            }
          }
        }

        .item-add {
          width: 90px;
          height: 71px;
          background-color: rgba(235, 235, 235, 1);
          background-image: url(../../assets/home/node/nav_add_btn.svg);
          background-size: 20px 20px;
          background-repeat: no-repeat;
          background-position: center center;
          display: inline-block;
          vertical-align: top;
          position: relative;
          .item-add-line {
            position: absolute;
            left: -1px;
            top: 0px;
            width: 1px;
            height: 100%;
            // background-color: #ffffff;
            background-image: url("../../assets/home/node/tab_line.png");
            background-size: 1px 52px;
            background-repeat: no-repeat;
            background-position: left center;
          }
        }

        .item-add:hover {
          cursor: pointer;
          // opacity: 0.8;
          background-color: #f0f3f8;
        }

        .activeWrap {
          position: relative;

          .activeLeftBg {
            position: absolute;
            top: -18px;
            z-index: 1;
            left: -12px;
            width: 225px;
            height: 105px;
            background-image: url("../../assets/home/node/tab_bg1.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
          .activeRightBg {
            position: absolute;
            top: -18px;
            z-index: 1;
            left: -23px;
            width: 224px;
            height: 105px;
            background-image: url("../../assets/home/node/tab_bg2.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
          .activeMiddleBg {
            position: absolute;
            top: -18px;
            z-index: 1;
            left: -24px;
            width: 237px;
            height: 105px;
            background-image: url("../../assets/home/node/tab_bg3.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
        }
      }
      .list::-webkit-scrollbar {
        display: none;
      }
      .nopadding {
        padding-left: 0;
      }
    }
  }
}

.bind-result-wrap {
  position: absolute;
  padding-top: 1px;
  text-align: center;
  height: 178px;
  width: 300px;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -90px;
  z-index: 10;
  padding-left: 31px;
  padding-right: 31px;
  font-size: 12px;
  color: #f5f5f5;
  background-color: #ffffff;
  border-radius: 5px;
  box-sizing: border-box;
  box-shadow: 0px 0px 12px 2px #cccccc;

  .close_btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 10px;
    background-image: url(../../assets/common/close4.svg);
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 2;
  }
  .close_btn:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  .bind-result-text1 {
    margin-top: 30px;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: bolder;
    color: #333333;
  }
  .bind-result-text2 {
    color: #999999;
    font-size: 14px;
  }

  .btns {
    text-align: center;
    margin-top: 30px;
  }

  .pay_btn {
    display: inline-block;
    vertical-align: top;
    width: 88px;
    height: 36px;
    line-height: 36px;
    color: #5f4509;
    background-color: #e9c29b;
    background-image: linear-gradient(
      140deg,
      #f2d7b3 4%,
      #e9c29b 57%,
      #d9ad84 100%
    );
    box-shadow: 0px 3px 10px 1px rgba(131, 106, 46, 0.1);
    border-radius: 58px 58px 58px 58px;
    opacity: 1;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
  }
  .pay_btn:hover {
    opacity: 0.9;
    cursor: pointer;
  }

  .qun_btn {
    display: inline-block;
    vertical-align: top;
    width: 88px;
    height: 36px;
    line-height: 36px;
    color: #ffffff;
    background-color: rgba(31, 93, 227, 1);
    box-shadow: 0px 3px 10px 1px rgba(131, 106, 46, 0.1);
    border-radius: 58px 58px 58px 58px;
    opacity: 1;
    text-align: center;
    margin: 0 auto;
    font-size: 14px;
  }
  .qun_btn:hover {
    opacity: 0.9;
    cursor: pointer;
  }

  .cancel_btn {
    display: inline-block;
    vertical-align: top;
    margin: 0 auto;
    border-radius: 20px;
    width: 88px;
    height: 36px;
    line-height: 36px;
    margin-right: 15px;
    font-size: 14px;
    background-color: rgba(230, 230, 230, 1);
    color: rgba(153, 153, 153, 1);
    text-align: center;
    text-decoration: none;
  }
  .cancel_btn:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  .btns.vip_btns {
    .cancel_btn {
      margin-left: 0px;
    }
  }
}
</style>